module.exports = __webpack_public_path__ + "static/img/kj1-7.8fe261e.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/kj1-7.png
// module id = 925
// module chunks = 0